import * as t from "io-ts";

export const IconV = t.type({
  id: t.number,
  slug: t.string,
  name: t.string,
  svgCode: t.string,
  iconSetSlug: t.string
});

export type Icon = t.TypeOf<typeof IconV>;

export type IconSetUnawareIcon = Omit<Icon, "iconSetSlug" | "id">;

const IconSetV = t.type({
  slug: t.string,
  name: t.string,
  custom: t.boolean
});

export type IconSet = t.TypeOf<typeof IconSetV>;

export const IconSetsV = t.array(IconSetV);

// TODO - this type has nothing to do with IconSets. It has to do with the SVG icons used by the builder UI. It doesn't belong in this file.
export type IconRotation = "90" | "180" | "270";
